// extracted by mini-css-extract-plugin
module.exports = {"label":"Label--label--2jVXS","disabled":"Label--disabled--bpNCV","groupLabel":"Label--groupLabel--IWOH_","colorDark":"Label--colorDark--eJzWf"};